import React from "react";

const AddIcon = ({ cls }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={cls}
    >
      <g id="new" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Client-&gt;--Add-New-Client-&gt;Client-Details"
          transform="translate(-1303.000000, -562.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <g id="card" transform="translate(228.000000, 200.000000)">
            <g id="sector" transform="translate(570.000000, 317.000000)">
              <g id="input-file" transform="translate(0.000000, 30.000000)">
                <g id="plus" transform="translate(504.000000, 14.000000)">
                  <polygon
                    id="+"
                    points="8.96551724 14.3295019 8.96551724 8.75095785 14.6666667 8.75095785 14.6666667 6.94252874 8.96551724 6.94252874 8.96551724 1.33333333 7.03448276 1.33333333 7.03448276 6.94252874 1.33333333 6.94252874 1.33333333 8.75095785 7.03448276 8.75095785 7.03448276 14.3295019"
                  ></polygon>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default AddIcon;
